import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSliderInput } from './uitk-slider-input.esm.js';
import styles from './uitk-slider.css';

var getClassNameList = classNames.bind(styles);
var UitkSlider = function (props) {
    var disabled = props.disabled, formatSecondaryValueForDisplay = props.formatSecondaryValueForDisplay, formatValueForDisplay = props.formatValueForDisplay, gap = props.gap, handleAfterChange = props.handleAfterChange, handleChange = props.handleChange, lowerValue = props.lowerValue, max = props.max, min = props.min, name = props.name, primaryLabel = props.primaryLabel, secondaryLabel = props.secondaryLabel, step = props.step, type = props.type, upperValue = props.upperValue, value = props.value;
    var _a = React.useState(''), active = _a[0], setActive = _a[1];
    var _b = React.useState(false), isFirefoxFallback = _b[0], setIsFirefoxFallback = _b[1];
    var _c = React.useState(0), gapWidth = _c[0], setGapWidth = _c[1];
    var _d = React.useState(false), mounted = _d[0], setMounted = _d[1];
    var sliderRef = React.createRef();
    var checkSliderWidth = function () {
        var newGap = gap || 0;
        var ref = sliderRef && sliderRef.current;
        var width = ref && ref.offsetWidth;
        if (width) {
            setGapWidth(Math.floor(((max - min) * newGap) / width));
        }
    };
    var checkFFBrowserFallback = function () {
        // eslint-disable-next-line no-negated-condition
        setIsFirefoxFallback(typeof window !== 'undefined' ? /Firefox\//.test(window.navigator.userAgent) : false);
    };
    React.useEffect(function () {
        setMounted(true);
        if (type === 'dual') {
            checkSliderWidth();
            checkFFBrowserFallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleChangeEvt = function (primary, secondary, event) {
        handleChange(primary, secondary, event);
    };
    var handleAfterChangeEvt = function (primary, secondary, event) {
        if (typeof handleAfterChange === 'function') {
            handleAfterChange(primary, secondary, event);
        }
    };
    var onActive = function () {
        if (typeof type !== 'undefined')
            setActive(type);
    };
    var getDisabled = function () { return !mounted || disabled; };
    var isDual = isFirefoxFallback ? false : type === 'dual';
    var fieldClasses = ['uitk-slider-container'];
    var formatSecondaryValueForDualSlider = typeof formatSecondaryValueForDisplay === 'function' ? formatSecondaryValueForDisplay : formatValueForDisplay;
    var cssStyles = {
        '--min': min,
        '--max': max,
        '--step': step
    };
    if (getDisabled()) {
        fieldClasses.push('uitk-slider-container-disabled');
    }
    if (step === undefined) {
        fieldClasses.push('uitk-slider-container-no-step');
    }
    return (React.createElement("div", { className: getClassNameList(fieldClasses), ref: sliderRef, style: cssStyles },
        type === 'dual' && isFirefoxFallback && React.createElement("input", { type: "hidden", value: lowerValue, name: name }),
        React.createElement(UitkSliderInput, __assign({}, props, { type: isDual ? 'primary' : 'single', name: name, max: isDual ? upperValue : max, value: isDual ? lowerValue : value || upperValue, absoluteMax: max, absoluteMin: min, gap: gapWidth, isActive: active === 'primary', onActive: onActive, disabled: getDisabled(), handleChange: handleChangeEvt, handleAfterChange: handleAfterChangeEvt, formatValueForDisplay: formatValueForDisplay, label: isDual ? primaryLabel : undefined })),
        isDual && (React.createElement(UitkSliderInput, __assign({}, props, { type: "secondary", name: name, min: lowerValue, value: upperValue, absoluteMax: max, absoluteMin: min, gap: gapWidth, isActive: active === 'secondary', onActive: onActive, disabled: getDisabled(), handleChange: handleChangeEvt, handleAfterChange: handleAfterChangeEvt, formatValueForDisplay: formatSecondaryValueForDualSlider, label: secondaryLabel })))));
};
UitkSlider.displayName = 'UitkSlider';

export { UitkSlider };
